// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-components-alert-alert-module__message--TDhPd {
  padding: 5px 10px;
  border-radius: 4px;
}

.src-js-components-alert-alert-module__hidden--XRGsW {
  display: none;
  visibility: hidden;
}

.src-js-components-alert-alert-module__closeIcon--Itlh0 {
  float: right;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/alert/alert.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".message {\n  padding: 5px 10px;\n  border-radius: 4px;\n}\n\n.hidden {\n  display: none;\n  visibility: hidden;\n}\n\n.closeIcon {\n  float: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"message": `src-js-components-alert-alert-module__message--TDhPd`,
	"hidden": `src-js-components-alert-alert-module__hidden--XRGsW`,
	"closeIcon": `src-js-components-alert-alert-module__closeIcon--Itlh0`
};
export default ___CSS_LOADER_EXPORT___;
